// "Quick View" button shown over a product card image on hover. Must sit inside a
// `group relative overflow-hidden` image wrapper.
//
// The dim is a plain overlay element: a `box-shadow: 0 0 0 5000px` on the button animated a ~10,000px
// compositor layer (every <button> has `transition-transform`) and flashed the page white.
const QuickViewButton = ({ onClick, dataTestId }: { onClick: () => void; dataTestId?: string }) => (
  <>
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-black/50 opacity-0 transition-opacity duration-300 group-hover:opacity-100 max-lg:hidden"
    />
    <button
      type="button"
      onClick={onClick}
      data-testid={dataTestId}
      className="quick-view-button absolute left-[50%] top-[80%] h-fit min-w-[20%] translate-x-[-50%] scale-0 cursor-pointer items-center bg-white py-2 leading-[1.17] opacity-0 group-hover:scale-100 group-hover:opacity-100 max-lg:hidden"
    >
      Quick View
    </button>
  </>
);

export default QuickViewButton;
